import { render, staticRenderFns } from "./URLLink.vue?vue&type=template&id=a4a2aab2&scoped=true&"
import script from "./URLLink.vue?vue&type=script&lang=js&"
export * from "./URLLink.vue?vue&type=script&lang=js&"
import style0 from "./URLLink.vue?vue&type=style&index=0&id=a4a2aab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a2aab2",
  null
  
)

export default component.exports